import { render, staticRenderFns } from "./weekend.vue?vue&type=template&id=683f286f&"
import script from "./weekend.vue?vue&type=script&lang=js&"
export * from "./weekend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports